import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/* フェイクテーブルリスト */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLW410030_01,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
  },
  {
    title: "退職者名",
    keyword: "staffName",
    type: "text",
  },
  {
    title: "請求書の提出完了日",
    keyword: "retirementInvoiceReceptionDay",
    type: "text",
  },
  { title: "被共済職員期間", keyword: "maePeriod", type: "text" },
  {
    title: "取下げ理由",
    keyword: "reason",
    disabled: true,
    inputProps: { maxLength: 500 },
  },
];

/* バリデーションチェック */
const schema = {
  memo: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "500"),
    },
  },
};
export { fakeTableList, schema };
